export default "__VITE_ASSET__B7qu3NZs__"